import template from './contact-bookings.tpl.html';
import rsvpSingleMessageModalCreator from '../../../modules/messages/helpers/rsvp-single-message-modal-creator';

class ContactBookingsController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.state = this.injector.get('$state');
        this.acl = this.injector.get('Acl');
        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.modal = this.injector.get('$uibModal');
        this.translate = this.injector.get('$translate');

        this.data = [];
        this.rsvpsFastPipe = this.injector.get('Rsvps').create({
            persists: false,
            listView: 'UpcomingBookings'
        });
        this._configureFastPipe();
        this.scope.$watch(() => {
            return this.contact;
        }, () => {
            if (this.contact) {
                this._updateFastPipeData();
            }
        });
    }

    _configureFastPipe() {
        const columns = [
            {
                key: 'contact.id',
                type: 'integer',
                visible: true
            },
            {
                key: 'guestlist.id',
                type: 'integer',
                visible: true
            },
            {
                key: 'guestlist.name',
                type: 'string',
                visible: true
            },
            {
                key: 'code',
                type: 'string',
                visible: true
            },
            {
                key: 'guestlist.date',
                type: 'datetime',
                visible: false
            },
            {
                key: 'status',
                type: 'string',
                visible: true
            },
            {
                key: 'pax_planned',
                type: 'integer',
                visible: true
            },
            {
                key: 'pax_actual',
                type: 'integer',
                visible: true
            }
        ];

        this.rsvpsFastPipe.commit('setColumns', columns);
    }

    _updateFastPipeData() {
        this._configureFastPipe();
        this.rsvpsFastPipe.commit('setSort', {'guestlist.date': 'asc'});
        this.rsvpsFastPipe.commit('setPermanentFilters', {'contact.id': this.contact.id});
        this.rsvpsFastPipe.dispatch('getData').then(() => {
            this.items = this.rsvpsFastPipe.state.data;
        });
    }

    openRsvpDetails(rsvp) {
        this.state.go('app.guestlists.rsvps.details.overview', {gid: rsvp.guestlist.id, id: rsvp.id});
    }

    editRsvp(rsvp) {
        this.state.go('app.guestlists.rsvps.details.edit', {gid: rsvp.guestlist.id, id: rsvp.id});
    }

    deleteRsvp(rsvp) {

        // @todo new alert - swal works, booking deleted but throws error and doesn't show success msg
        const translatedValue = (path) => {
            return this.translate.instant(`components.ask-to-delete-booking.${path}`);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content'),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
            })
            .then(() => {
                this.api.delete(`rsvps/${rsvp.id}`)
                    .then(() => {
                        if (this.store) {
                            this.store.dispatch('getData');
                        }
                        // @todo joanna will translate
                        return this.alert.success('Archived', `Successfully archived booking`);
                    }, err => this.alert.handle(err));
            }, err => this.alert.handle(err));
    }

    sendEmail(rsvp) {
        this.injector.get('$q').all([
            this.api.get(`rsvps/${rsvp.id}`).then((response) => {
                return response.data.data;
            }),
            this.api.get(`guestlists/${rsvp.guestlist.id}`).then((response) => {
                return response.data.data;
            })
        ]).then((models) => {
            rsvpSingleMessageModalCreator(this.injector, models[0], this.contact, {
                guestlist: models[1]
            });
        })
    }
}

ContactBookingsController.$inject = [
    '$scope',
    '$injector'
]

angular
    .module('festzelt-os.components')
    .component('contactBookings', {
        bindings: {
            contact: '<',
            store: '<'
        },
        controller: ContactBookingsController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/components/contact-bookings/contact-bookings.js